import React from "react"
import WistiaPlayer from "./WistiaPlayer"
import { Link } from "gatsby"
import { routes } from "@/utils/routes"

export type VideoType = {
  title: string
  description?: string
  placeholder: {
    asset: {
      url: string
    }
  }
  videoUrl?: string
}

type Props = {
  video: VideoType
}

const VideoPage: React.FC<Props> = ({ video }) => {
  // Handle missing video data
  const videoData = video || {
    description: "Video Description",
    videoUrl: null,
    title: "Video Title"
  };

  return (
    <div className="py-24">
      <div className="container" id="video-page-container">
        <h2 className="normal-case text-[36px] sm:text-[46px] font-gilroy font-bold leading-[0.9] pb-4 mb-8">
          {videoData.description}
        </h2>

        {videoData.videoUrl != null ?
          <WistiaPlayer
            videoStyle={{
              width: "100%",
              height: "100%",
            }}
            videoID={videoData.videoUrl}
            className="aspect-video"
          />
          :
          <img src="/images/placeholder.jpg" alt={videoData.title} className="w-full" />
        }

        <div className="md:mt-8 mb-8 flex justify-end">
          <Link
            className="inline-block bg-primary text-dark px-8 py-4 rounded-sm font-gilroy font-bold text-xl hover:bg-[#d9a01d] transition-colors text-center"
            to={routes.donate()}
          >
            DONATE NOW
          </Link>
        </div>

      </div>
    </div>
  )
}

export default VideoPage
